import { Upcoming } from '@mui/icons-material';
import { blueGrey } from '@mui/material/colors';
import React from 'react'

export const getSongStatusBgColor = (songStatus) => {
    songStatus = songStatus.replaceAll(' ', '_').toLowerCase();
    if (songStatus) {
        switch (songStatus) {
            case 'unverified':
                {
                    return '#FF0000'
                }
            case 'in_review':
            case 'underreview':
                case 'UnderReview':
                {
                    return "#DAA827"
                }
            case 'ready_for_release':
                // case 'underreview':
                {
                    return "#FCAC62"
                }
            case 'released':
                case 'Approved':
                    case 'approved':
                {
                    return ' #3EBD02'
                }
            case 'rejected':
                case 'Rejected':
                {
                    return '#E92726'
                }
            case 'completed':
                case 'Completed':
                {
                    return ' #3EBD02'
                }
            case 'upcoming':
                {
                    return "#eafdee"
                }
            case 'new':
                {
                    return "e8e8e8"
                }
            case 'Approved':
                {
                    return "#3EBD02"
                }
            default:
                return '#6c757d'
        }
    }
}


export const getSongStatusTextColor = (songStatus) => {

  const normalized = songStatus.replaceAll(" ", "_").toLowerCase();

  if (normalized === "upcoming") {
    return "#219653"; 
  }
  if (normalized === "new") {
    return "#7A7A7A"; 
  }
  if(normalized === "UnderReview"){
    return '#fff'
  }

  return "#fff"; // default white
};